const choices = {
    PER: 'PER',
    Prefon: 'Prefon',
    other: 'Autre',
};

export default choices;
